<template>
  <power-bi code="eyJrIjoiOTRmNjdhZDAtNjAxNy00ZTE2LTkyZmYtNjI4MGM1MTVkMTg1IiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
